import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { MdCancel } from "react-icons/md";
import { convertPersianToLatinDigits } from "../../utils/function.utils";

const SelectRouteMultiple = (props) => {
  const [newOption, setNewOption] = useState([]);
  const [newSpinnerState, setNewSpinnerState] = useState(false);
  const [newInputSearchValue, setNewInputSearchValue] = useState("");
  const [newArray, setNewArray] = useState(["4"]);
  const [newScrollPage, setNewScrollPage] = useState(2);
  const [changePageSpinner, setChangePageSpinner] = useState(false);
  const [newScrollFetching, setNewScrollFetching] = useState(true);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // اضافه کردن حالت برای جستجو در selectedOptions
  const [selectedSearchValue, setSelectedSearchValue] = useState("");
  const useRouterRef = useRef();
  const optionRef = useRef();

  useEffect(() => {
    if (props.pageType === "edit") {
      setSelectedOptions(props.editDataValue);
    }

    document.body.addEventListener("click", (event) => {
      if (!event.target.matches("." + props.machOptionsClass)) {
        setNewOption([]);
      }
    });
  }, []);

  const getOptionsHandler = (event) => {
    const inputValue = event.target.value;
    setNewInputSearchValue(event.target.value);
    setNewScrollPage(2);
    setNewArray(["4"]);
    setChangePageSpinner(false);
    if (inputValue.length === 0) {
      setNewOption([{ label: "برای جستجو تایپ کنید", value: "" }]);
    }
    if (inputValue.length > 1) {
      setNewSpinnerState(true);
      axios
        .get(`${props.itemRoute}${inputValue}&per_page=10`)
        .then((res) => {
          if (res.data.data.data.length === 0) {
            setNewOption([{ label: "داده ای یافت نشد", value: "" }]);
          } else {
            const array = res.data.data.data.filter((item) => {
              const selected = selectedOptions.find((item2) => {
                return item.value === item2.value;
              });
              return item && selected === undefined;
            });
            setNewOption(array);
          }
        })
        .then(() => setNewSpinnerState(false))
        .catch((error) => console.log(error));
    }
  };

  function deleteOption(event) {
    let array = selectedOptions;
    let array2 = array.filter((item) => {
      return +item.value !== +event.currentTarget.id;
    });
    setSelectedOptions(array2);
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, array2);
    } else {
      let object = props.inputData;
      object[props.item.key] = array2;
      props.setInputData(object);
    }
  }

  const optionClickHandler = (event) => {
    const optionValue = event.target.getAttribute("value");
    setChangePageSpinner(false);
    setNewSpinnerState(false);

    if (optionValue === "") {
      return;
    }
    let array = selectedOptions;
    if (
      array.find((item) => {
        return item.label === event.target.getAttribute("label");
      }) === undefined
    ) {
      array.push({
        label: event.target.getAttribute("label"),
        value: Number(event.target.getAttribute("id")),
      });
    }
    setSelectedOptions(array);
    useRouterRef.current.value = "";
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, array);
    } else {
      let object = props.inputData;
      object[props.item.key] = array;
      props.setInputData(object);
    }
    setNewOption([]);
  };

  const scrollFechtHandler = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom === true && newArray.length > 0) {
      setChangePageSpinner(true);
      if (newScrollFetching === true) {
        setNewScrollFetching(false);
        axios
          .get(
            `${props.itemRoute}${newInputSearchValue}&per_page=10&page=${newScrollPage}`,
          )
          .then(async (res) => {
            setNewArray(res.data.data.data);
            setChangePageSpinner(false);
            if (res.data.data.data.length > 0) {
              setNewSpinnerState(false);
              await setNewOption((prev) => [...prev, ...res.data.data.data]);
              await setNewScrollPage((prev) => prev + 1);
            }
          })
          .then(() => setNewScrollFetching(true))
          .catch((error) => {
            console.log(error);
            setChangePageSpinner(false);
          });
      }
    }
  };

  function focusHandler(event) {
    if (event.target.value.length === 0) {
      setNewOption([{ label: "برای جستجو تایپ کنید", value: "" }]);
    }
  }

  // تابع مدیریت جستجو در selectedOptions
  const handleSelectedSearch = (event) => {
    setSelectedSearchValue(event.target.value);
  };

  // فیلتر کردن selectedOptions بر اساس عبارت جستجو
  const filteredSelectedOptions = selectedOptions.filter((item) => {
    const searchValueLatin = convertPersianToLatinDigits(
      selectedSearchValue.toLowerCase(),
    );
    const itemLabelLatin = convertPersianToLatinDigits(
      item.label.toLowerCase(),
    );
    return itemLabelLatin.includes(searchValueLatin);
  });

  return (
    <div className="relative">
      <input
        type="text"
        className={`h-[38px] border border-edit_input_border rounded-[4px] px-3 w-full ${
          props.machOptionsClass
        } ${
          props.item.disabled !== undefined || props.item.disabled
            ? "bg-[#e9e9e9] cursor-not-allowed dark:bg-[#b5b5b5] text-edit_input_text_disabled"
            : "bg-white dark:bg-[#ffffffdd] text-edit_input_text"
        }`}
        onChange={getOptionsHandler}
        ref={useRouterRef}
        disabled={props.item.disabled}
        autoComplete="off"
        onFocus={focusHandler}
      />
      {/* فیلد جستجو برای selectedOptions */}
      <input
        type="text"
        className="h-[38px] border border-edit_input_border rounded-[4px] px-3 w-full my-4"
        placeholder="جستجو در گزینه‌های برای حذف..."
        value={selectedSearchValue}
        onChange={handleSelectedSearch}
        autoComplete="off"
      />
      <div className="flex flex-wrap gap-2 p-3 w-full bg-gray-50 dark:bg-gray-800 rounded-lg shadow-sm">
        {filteredSelectedOptions.length === 0 ? (
          <div className="w-full text-gray-500 dark:text-gray-400 text-sm p-3 text-center">
            گزینه‌ای انتخاب نشده است
          </div>
        ) : (
          filteredSelectedOptions.map((item) => (
            <div
              key={item.value}
              className="sm:w-[calc(33.33%-0.5rem)] w-full px-4 py-2 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-between gap-2 transition-all duration-200 hover:bg-blue-200 dark:hover:bg-blue-800"
            >
              <span className="text-gray-800 dark:text-gray-200 text-sm font-medium truncate">
                {item.label}
              </span>
              <button
                type="button"
                onClick={deleteOption}
                id={item.value}
                className="text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors duration-200"
              >
                <MdCancel className="w-5 h-5" />
              </button>
            </div>
          ))
        )}
      </div>
      {/*<div className="h-38 flex flex-wrap items-center justify-end gap-2 pt-[4px] px-1 w-fit">*/}
      {/*  {filteredSelectedOptions.map((item) => (*/}
      {/*      <div className="bg-[#9cc8cae1] w-fit px-[8px] rounded-xl h-[30px] flex items-center gap-1">*/}
      {/*        <span className="text-[#242424]">{item.label}</span>*/}
      {/*        <button type="button" onClick={deleteOption} id={item.value}>*/}
      {/*          <MdCancel className="text-stone-600"/>*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*  ))}*/}
      {/*</div>*/}
      <div
        className={`absolute z-[99] top-[38px] w-full bg-white ${
          newOption !== undefined && newOption.length !== 0
            ? "border shadow-md"
            : ""
        }`}
      >
        <ul
          className={`overflow-y-scroll ${
            newOption !== undefined && newOption.length !== 0
              ? " max-h-[140px]"
              : ""
          }`}
          onScroll={scrollFechtHandler}
        >
          {newSpinnerState ? (
            <li className="flex items-center gap-4 bg-white">
              <span className="inline-block animate-spin h-6 w-6 mr-3 rounded-[50%] bg- border-t-4 border-r-4 border-stone-500 mt-2 mb-2"></span>
              <span>در حال جستجو</span>
            </li>
          ) : (
            newOption !== undefined &&
            newOption.map((item, index) => (
              <li
                key={item.label + index}
                value={item.value}
                ref={optionRef}
                onClick={optionClickHandler}
                className={`px-[10px] py-[5px] bg-white cursor-pointer ${props.machOptionsClass} hover:bg-aside_background_menu`}
                label={item.label}
                id={item.value}
              >
                {item.label}
              </li>
            ))
          )}
        </ul>
        {changePageSpinner && (
          <div className="flex items-center justify-center gap-4 bg-white relative">
            <span className="inline-block animate-spin h-6 w-6 mr-3 rounded-[50%] bg- border-t-4 border-r-4 border-stone-500 mt-2 mb-2"></span>
            <span>در حال جستجو</span>
          </div>
        )}
      </div>
      <div className="mt-2 text-[.8rem] text-edit_input_validation">
        {props.children}
      </div>
    </div>
  );
};

export default SelectRouteMultiple;
